import PropTypes from 'prop-types'
import { Fragment } from 'react/jsx-runtime'
import { Link } from 'react-router'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/elements/breadcrumb'

/**
 * @typedef {Object} BreadcrumbItemObject
 * @property {string} [pathname] - Optional pathname for the breadcrumb link
 * @property {string} title - Title text for the breadcrumb
 * @property {string} [id] - Unique identifier for the breadcrumb item, falls back to title
 */

/**
 * @typedef {BreadcrumbItemObject | string} BreadcrumbItem
 */

/**
 *
 * @param {object} props
 * @param {(BreadcrumbItem)[]} props.breadcrumbs - Array of breadcrumb items to render
 * @returns
 */
function Breadcrumbs({ breadcrumbs }) {
  const expandedBreadcrumbs = breadcrumbs
    .map((crumb) => {
      if (typeof crumb === 'string') {
        return { pathname: null, title: crumb, id: crumb }
      }
      return crumb
    })
    .filter((crumb) => crumb.title && crumb.title.trim() !== '')

  return (
    <Breadcrumb data-testid="breadcrumbs">
      <BreadcrumbList>
        {expandedBreadcrumbs.map(({ pathname, title, id }, index) => {
          const isLast = index === expandedBreadcrumbs.length - 1

          return (
            <Fragment key={id || title}>
              <BreadcrumbItem>
                {pathname ? (
                  <BreadcrumbLink asChild>
                    <Link to={pathname}>{title}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage current={isLast}>{title}</BreadcrumbPage>
                )}
              </BreadcrumbItem>

              {!isLast && <BreadcrumbSeparator />}
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}

export default Breadcrumbs

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
}
